import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { UmsService } from '../ums.service';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ModalpopService } from '../modalpop.service';

@Component({
  selector: 'app-permission-dialog-box',
  templateUrl: './permission-dialog-box.component.html',
  styleUrls: ['./permission-dialog-box.component.scss']
})
export class PermissionDialogBoxComponent implements OnInit {
  permissionForm: FormGroup;
  allPages: any = [];
  tab = true;
  page = true;
  userPermission: any;
  UserCollege: any;
  adminenable: boolean = false;
  superenable: boolean = false;
  processenable: boolean = false;
  inputenable: boolean = false;
  errormessage: string;
  searchText: any;
  userlist: any;
  totalLength: any;
  id: any;
  rolesList: any;
  BranchList: any;
  userId: string;
  userdetails: any;
  collegedataList: any;
  filteredCollegeList: any;
  filteredCollegeListMultiple: any[] = [];
  submitpayload: any;
  perList = [];
  dialogRef: MatDialogRef<any>;
  stocktabenable: boolean;
  tabenable: boolean;
  view: boolean;
  roleList: any;
  filteredListOfRole: any;
  feesenable: boolean;
  ClgUni: any;
  Readonly = false;
  fcCodeList: any;
  filteredListFcCode: any;

  // Multi-college properties
  isMultipleCollege = false;
  allCollegesSelected = false;
  allCollegesList: any[] = [];

  // NEW: Module selection for multi-college mode
  selectedModuleForMulti: string = 'ALL';
  filteredModulesForMulti: any = [];

  status: any;
  submitButton = true;
  updateButton = false;
  deleteButton = false;
  cancelButton = false;
  loggedId: any;
  myimage: any;
  date: any;
  size: number = 5;
  page2: number = 1;
  isPassword = true;

  @Output() prev = new EventEmitter<void>();
  user_role: any;
  customerType: any;
  PView = false;
  listofCustomer: any;
  listofuser: any;
  dashboard_view: any;
  Tab1 = false;
  Tab2 = false;
  Tab3 = false;
  Tab4 = false;
  CreateTab1 = false;
  CreateTab2 = false;
  CreateTab3 = false;
  CreateTab4 = false;
  UpdateTab1 = false;
  UpdateTab2 = false;
  UpdateTab3 = false;
  UpdateTab4 = false;
  DeleteTab1 = false;
  DeleteTab2 = false;
  DeleteTab3 = false;
  DeleteTab4 = false;
  CreateTab = true;
  permission: any = [];
  user: any = [];
  selectedItemsList: any;
  listofcustuser: any;
  userSelectList: any = [];
  tempArray: any = [];
  customerRefId: any;
  userData: any;
  listOfRole: any;
  checkCust: Boolean = true;
  checkUser: Boolean = true;
  disableField: Boolean = false;
  mastertabenable: boolean = false;
  userType: any;
  custRefId: any;
  permissionList = [];
  permissionCreate = true;
  permissionUpdate = true;
  clinicRef: string;
  showclg = false;
  isDisable = true;
  userid: any;
  userNm: any;

  constructor(
    private fb: FormBuilder,
    private _snackBar: MatSnackBar,
    public umsService: UmsService,
    public router: Router,
    public dialog: MatDialog,
    public datepipe: DatePipe,
    private spinner: NgxSpinnerService,
    private modalPopupService: ModalpopService,
    private dialogRef2: MatDialogRef<PermissionDialogBoxComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.userid = sessionStorage.getItem('loginId');
    this.userNm = sessionStorage.getItem('loginName');

    this.initializeForm();
    this.initializePages();
    this.fetchRolelist();
    this.fetchFacultyCode();

    if (this.data && this.data.key == "Edit") {
      this.userId = this.data.selected.LoginId;
      this.prepopulation();
    } else if (this.data && this.data.key == "New") {
      this.userId = this.data.selected.LoginId;
    } else {
      if (this.userid) {
        this.prepopulation();
      } else {
        this.disableField = true;
      }
    }
  }

  initializeForm(): void {
    this.permissionForm = this.fb.group({
      "UserId": new FormControl(this.userid),
      "Usernm": new FormControl(this.userNm),
      "PermissionType": new FormControl('single'),
      "MultipleColleges": new FormControl([]),
      "UserRole": new FormControl('', Validators.required),
      "CgUi": new FormControl('', Validators.required),
      "CgId": new FormControl(''),
      "FcCode": new FormControl(''),
      "PSelect": new FormControl(false),
      "PageName": new FormControl(''),
      "PView": new FormControl(''),
      "PCreate": new FormControl(''),
      "PUpdate": new FormControl(''),
      "PDelete": new FormControl(''),
      "IsTab": new FormControl(''),
      "userPermission": new FormControl(),
      "menu": new FormControl(),
      userPermissionArr: this.fb.array([]),
    });
  }

  initializePages(): void {
    let arr = [];
    this.allPages = [];
    this.router.config.forEach((e, i) => {
      if (e.data !== undefined) {
        arr.push(e.data.name);
        if (this.allPages.indexOf(e.data.name) === -1) {
          this.allPages.push({
            PageName: e.data.name,
            PSelect: false,
            PView: false,
            PCreate: false,
            PUpdate: false,
            PDelete: false,
            IsTab: e.data.IsTab,
            MenuName: e.data.MenuName
          });
        }

        if (e.data.name == 'Reports') {
          this.Readonly = true;
        }
      }
    });

    // Prepare module dropdown for multi-college mode
    this.filteredModulesForMulti = [
      { PageName: 'ALL', DisplayName: 'All Modules' },
      ...this.allPages.map(page => ({
        PageName: page.PageName,
        DisplayName: page.PageName
      }))
    ];
  }

  onPermissionTypeChange(event: any): void {
    this.isMultipleCollege = event.value === 'multiple';

    if (this.isMultipleCollege) {
      this.permissionForm.get('MultipleColleges').setValidators(Validators.required);
      this.permissionForm.get('Usernm').clearValidators();
      this.permissionForm.get('CgId').clearValidators();
      this.getAllCollegesForMultipleSelection();
    } else {
      this.permissionForm.get('MultipleColleges').clearValidators();
      this.permissionForm.get('Usernm').setValidators(Validators.required);
    }

    this.permissionForm.get('MultipleColleges').updateValueAndValidity();
    this.permissionForm.get('Usernm').updateValueAndValidity();
    this.permissionForm.get('CgId').updateValueAndValidity();
  }

  getAllCollegesForMultipleSelection(): void {
    this.spinner.show();
    const payload = {};
    payload['CgCode'] = '';

    this.umsService.getCollege(payload).subscribe(
      (res) => {
        if (res.status && res.data) {
          this.allCollegesList = res.data;
          this.filteredCollegeListMultiple = this.allCollegesList.slice();
        }
        this.spinner.hide();
      },
      (error: HttpErrorResponse) => {
        this.allCollegesList = [];
        this.filteredCollegeListMultiple = [];
        this.spinner.hide();
        console.error('Error fetching colleges:', error);
      }
    );
  }

  toggleSelectAllColleges(): void {
    if (this.allCollegesSelected) {
      const allFilteredCollegeCodes = this.filteredCollegeListMultiple.map(college => college.CgCode);
      this.permissionForm.get('MultipleColleges').setValue(allFilteredCollegeCodes);
    } else {
      this.permissionForm.get('MultipleColleges').setValue([]);
    }
  }

  getCollegeData(): void {
    if (this.userPermission && this.userPermission[0].CgUi == 'C') {
      this.UserCollege = this.userPermission[0].CgId;
    } else {
      this.UserCollege = '';
    }

    this.spinner.show();
    const payload = {};
    payload['CgCode'] = this.UserCollege;

    this.umsService.getCollege(payload).subscribe(
      (res) => {
        this.collegedataList = res.data;
        this.filteredCollegeList = this.collegedataList.slice();
        this.spinner.hide();
      },
      (ERROR: HttpErrorResponse) => {
        this.collegedataList = [];
        this.spinner.hide();
      }
    );
  }

  selsectClgUni(event: any): void {
    const selectedValue = event.value;
    if (selectedValue == 'C') {
      this.showclg = true;
      if (!this.isMultipleCollege) {
        this.getCollegeData();
      } else {
        this.getAllCollegesForMultipleSelection();
      }
      this.isDisable = false;
    } else {
      this.isDisable = true;
      this.showclg = false;
      let uni = this.umsService.secretdata['ClubPartTrans'];
      this.permissionForm.controls['CgId'].setValue(uni);
    }
  }

  submitPermi(): void {
    const formValue = this.permissionForm.value;

    if (formValue.PermissionType === 'multiple') {
      this.submitMultipleCollegePermissions();
    } else {
      this.submitSingleCollegePermission();
    }
  }

  submitSingleCollegePermission(): void {
    let payload = {}
    payload = this.permissionForm.value;
    let finalpayload = {}
    finalpayload['userPermissionArr'] = this.allPages;
    let sequId = 0;
    this.allPages.forEach(element => {
      element['sequId'] = sequId += 1;
      element['UserId'] = this.permissionForm.value.UserId;
      element['UserRole'] = this.permissionForm.value.UserRole;
      element['CgUi'] = this.permissionForm.value.CgUi;
      element['CgId'] = this.permissionForm.value.CgId;
      element['FcCode'] = this.permissionForm.value.FcCode;
      this.umsService.addPermission(element).subscribe(res => {
        if (res.status) {

        }
        else {
          ;
        }
      });
    });
    let data = {};
    data['message'] = "Submitted Successfully";
    data['title'] = 'Information';
    data['icon'] = 'fas fa-check';
    this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
      this.dialogRef2?.close();
      this.prev.emit();
    });
  }

  submitMultipleCollegePermissions(): void {
    const selectedCollegeCodes = this.permissionForm.value.MultipleColleges;

    const userIds: number[] = [];
    const collegeCodes: string[] = [];

    selectedCollegeCodes.forEach((collegeCode: string) => {
      const college = this.allCollegesList.find(c => c.CgCode === collegeCode);
      if (college && college.UserId) {
        userIds.push(college.UserId);
        collegeCodes.push(collegeCode);
      }
    });

    if (userIds.length === 0) {
      let data = {
        message: "No valid user IDs found for selected colleges",
        title: 'Error',
        icon: 'fas fa-times'
      };
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      return;
    }

    // Filter pages based on selected module
    let pagesToSubmit = this.allPages;
    if (this.selectedModuleForMulti !== 'ALL') {
      pagesToSubmit = this.allPages.filter(page => page.PageName === this.selectedModuleForMulti);
    }

    let payload = {
      UserIds: JSON.stringify(userIds),
      CollegeCodes: JSON.stringify(collegeCodes),
      UserRole: this.permissionForm.value.UserRole,
      CgUi: 'C',
      FcCode: this.permissionForm.value.FcCode || null,
      Permissions: JSON.stringify(pagesToSubmit.map((element, index) => ({
        SequId: index + 1,
        PageName: element.PageName,
        PSelect: element.PSelect ? 1 : 0,
        PView: element.PView ? 1 : 0,
        PCreate: element.PCreate ? 1 : 0,
        PUpdate: element.PUpdate ? 1 : 0,
        PDelete: element.PDelete ? 1 : 0,
        IsTab: element.IsTab ? 1 : 0,
        MenuName: element.MenuName || ''
      })))
    };

    this.spinner.show();
    this.umsService.upsertMultiplePermissions(payload).subscribe(
      res => {
        this.spinner.hide();
        if (res.status) {
          let moduleText = this.selectedModuleForMulti === 'ALL' ? 'all modules' : `${this.selectedModuleForMulti} module`;
          let data = {
            message: `Permissions for ${moduleText} assigned successfully to ${selectedCollegeCodes.length} college(s).`,
            title: 'Information',
            icon: 'fas fa-check'
          };
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.dialogRef.afterClosed().subscribe(result => {
            this.dialogRef2?.close();
            this.prev.emit();
          });
        } else {
          let data = {
            message: res.message || "Failed to assign permissions",
            title: 'Error',
            icon: 'fas fa-times'
          };
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        }
      },
      (error: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {
          message: error.error?.message || "An error occurred",
          title: 'Error',
          icon: 'fas fa-times'
        };
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    );
  }

  submit(): void {
    if (this.permissionForm.invalid) {
      this.permissionForm.get('UserRole').markAsTouched();
      this.permissionForm.get('CgUi').markAsTouched();

      if (this.isMultipleCollege) {
        this.permissionForm.get('MultipleColleges').markAsTouched();
      } else if (this.permissionForm.value.CgUi === 'C') {
        this.permissionForm.get('CgId').markAsTouched();
      }

      return;
    } else {
      this.submitPermi();
    }
  }

  update(): void {
    if (this.permissionForm.invalid) {
      this.permissionForm.get('UserRole').markAsTouched();
      this.permissionForm.get('CgUi').markAsTouched();

      if (this.isMultipleCollege) {
        this.permissionForm.get('MultipleColleges').markAsTouched();
      } else if (this.permissionForm.value.CgUi === 'C') {
        this.permissionForm.get('CgId').markAsTouched();
      }

      return;
    }

    const formValue = this.permissionForm.value;

    if (formValue.PermissionType === 'multiple') {
      this.updateMultipleCollegePermissions();
    } else {
      this.updateSingleCollegePermission();
    }
  }

  updateSingleCollegePermission(): void {
    let payload = {}
    payload = this.permissionForm.value;
    let finalpayload = {}
    finalpayload['userPermissionArr'] = this.allPages;
    this.allPages.forEach(element => {
      element['UserId'] = this.permissionForm.value.UserId;
      element['UserRole'] = this.permissionForm.value.UserRole;
      element['CgUi'] = this.permissionForm.value.CgUi;
      element['CgId'] = this.permissionForm.value.CgId;
      element['FcCode'] = this.permissionForm.value.FcCode;
      this.umsService.updatePermission(element).subscribe(res => {
        if (res.status) {
        }
        else {
          ;
        }
      });
    });
    let data = {};
    data['message'] = "Updated Successfully";
    data['title'] = 'Information';
    data['icon'] = 'fas fa-check';
    this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
      this.ngOnInit();
    });
  }

  updateMultipleCollegePermissions(): void {
    const selectedCollegeCodes = this.permissionForm.value.MultipleColleges;

    const userIds: number[] = [];
    const collegeCodes: string[] = [];

    selectedCollegeCodes.forEach((collegeCode: string) => {
      const college = this.allCollegesList.find(c => c.CgCode === collegeCode);
      if (college && college.UserId) {
        userIds.push(college.UserId);
        collegeCodes.push(collegeCode);
      }
    });

    if (userIds.length === 0) {
      let data = {
        message: "No valid user IDs found for selected colleges",
        title: 'Error',
        icon: 'fas fa-times'
      };
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      return;
    }

    // Filter pages based on selected module
    let pagesToUpdate = this.allPages;
    if (this.selectedModuleForMulti !== 'ALL') {
      pagesToUpdate = this.allPages.filter(page => page.PageName === this.selectedModuleForMulti);
    }

    let payload = {
      UserIds: JSON.stringify(userIds),
      CollegeCodes: JSON.stringify(collegeCodes),
      UserRole: this.permissionForm.value.UserRole,
      CgUi: 'C',
      FcCode: this.permissionForm.value.FcCode || null,
      Permissions: JSON.stringify(pagesToUpdate.map((element, index) => ({
        SequId: index + 1,
        PageName: element.PageName,
        PSelect: element.PSelect ? 1 : 0,
        PView: element.PView ? 1 : 0,
        PCreate: element.PCreate ? 1 : 0,
        PUpdate: element.PUpdate ? 1 : 0,
        PDelete: element.PDelete ? 1 : 0,
        IsTab: element.IsTab ? 1 : 0,
        MenuName: element.MenuName || ''
      })))
    };

    this.spinner.show();
    this.umsService.upsertMultiplePermissions(payload).subscribe(
      res => {
        this.spinner.hide();
        if (res.status) {
          let moduleText = this.selectedModuleForMulti === 'ALL' ? 'all modules' : `${this.selectedModuleForMulti} module`;
          let data = {
            message: `Permissions for ${moduleText} updated successfully for ${selectedCollegeCodes.length} college(s).`,
            title: 'Information',
            icon: 'fas fa-check'
          };
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.dialogRef.afterClosed().subscribe(result => {
            this.ngOnInit();
          });
        } else {
          let data = {
            message: res.message || "Failed to update permissions",
            title: 'Error',
            icon: 'fas fa-times'
          };
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        }
      },
      (error: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {
          message: error.error?.message || "An error occurred",
          title: 'Error',
          icon: 'fas fa-times'
        };
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    );
  }

  prepopulation(): void {
    this.submitButton = true;
    this.updateButton = false;
    this.spinner.show();

    let payload = {};
    payload['UserId'] = this.userid;

    this.fetchRolelist();
    this.umsService.getPermission(payload).subscribe(
      res => {
        this.spinner.hide();

        if (res.status) {
          let aaaryy = [];
          aaaryy = res.data;
          this.submitButton = false;
          this.updateButton = true;

          const ids = aaaryy.map(o => o.PermissionId);
          let data = res.data[0];

          this.allPages = this.allPages.map(page => {
            const existingPermission = aaaryy.find(p => p.PageName === page.PageName);
            if (existingPermission) {
              return {
                ...page,
                PermissionId: existingPermission.PermissionId,
                PSelect: existingPermission.PSelect || false,
                PView: existingPermission.PView || false,
                PCreate: existingPermission.PCreate || false,
                PUpdate: existingPermission.PUpdate || false,
                PDelete: existingPermission.PDelete || false
              };
            }
            return page;
          });

          this.updatePagePermissions(this.allPages);

          this.ClgUni = data.CgUi;
          if (data.CgUi == 'C') {
            this.showclg = true;
            this.getCollegeData();
          }

          if (data.CgUi == 'C') {
            this.isDisable = false;
          } else {
            this.isDisable = true;
          }

          this.permissionForm.patchValue({
            UserId: data.UserId,
            Usernm: this.userNm,
            PermissionType: 'single',
            UserRole: data.UserRole,
            CgUi: data.CgUi,
            CgId: data.CgId,
            FcCode: data.FcCode,
            PSelect: data.PSelect ? data.PSelect : false
          });
        } else {
          this.spinner.hide();
          this.submitButton = true;
          this.updateButton = false;

          this.allPages = this.allPages.map(page => ({
            ...page,
            PSelect: false,
            PView: false,
            PCreate: false,
            PUpdate: false,
            PDelete: false
          }));

          this.updatePagePermissions(this.allPages);
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
      }
    );
  }

  updatePagePermissions(pages: any[]): void {
    for (let i = 0; i < pages.length; i++) {
      if (pages[i].PageName == 'Reports') {
        this.Readonly = true;
      }

      if (pages[i].PageName == "Admin") {
        this.adminenable = pages[i].PView == true;
      }
      if (pages[i].PageName == "Master") {
        this.mastertabenable = pages[i].PView == true;
      }
      if (pages[i].PageName == "Supervisor") {
        this.superenable = pages[i].PView == true;
      }
      if (pages[i].PageName == "Processing") {
        this.processenable = pages[i].PView == true;
      }
      if (pages[i].PageName == "Input") {
        this.inputenable = pages[i].PView == true;
      }
      if (pages[i].PageName == "Fee") {
        this.feesenable = pages[i].PView == true;
      }
    }
  }

  fetchRolelist(): void {
    const payload = {};
    payload['CdType'] = 'Role';
    this.umsService.getCode(payload).subscribe((res) => {
      if (res.status) {
        this.roleList = res.data;
        this.filteredListOfRole = this.roleList.slice();
      }
    });
  }

  fetchFacultyCode(): void {
    const payload = {};
    this.umsService.getFaculty(payload).subscribe(res => {
      if (res.status) {
        this.fcCodeList = res.data;
        this.filteredListFcCode = this.fcCodeList.slice();
      }
    });
  }

  onTabChange(e: any): void {
    this.tab = e.target.checked;
  }

  onPageChange2(e: any): void {
    this.page = e.target.checked;
  }

  onSelectAllChange(e: any): void {
    if (e.target.checked == true) {
      for (let i = 0; i < this.allPages.length; i++) {
        if (e.target.value == this.allPages[i].PageName) {
          this.allPages[i].PSelect = true;
          this.allPages[i].PView = true;
          this.allPages[i].PCreate = true;
          this.allPages[i].PUpdate = true;
          this.allPages[i].PDelete = true;
        }
        if (e.target.value == "Stock") {
          this.stocktabenable = true;
        }
        if (e.target.value == "Settings") {
          this.tabenable = true;
        }
      }
    }

    if (e.target.checked == false) {
      for (let i = 0; i < this.allPages.length; i++) {
        if (e.target.value == this.allPages[i].PageName) {
          this.allPages[i].PSelect = false;
          this.allPages[i].PView = false;
          this.allPages[i].PCreate = false;
          this.allPages[i].PUpdate = false;
          this.allPages[i].PDelete = false;
        }
        if (e.target.value == "Stock") {
          this.stocktabenable = false;
        }
        if (e.target.value == "Settings") {
          this.tabenable = false;
        }
      }
    }
  }

  onSelectAllPagesChange(e: any): void {
    if (e.checked == true) {
      for (let i = 0; i < this.allPages.length; i++) {
        this.allPages[i].PSelect = true;
        this.allPages[i].PView = true;
        this.allPages[i].PCreate = true;
        this.allPages[i].PUpdate = true;
        this.allPages[i].PDelete = true;
        this.tabenable = true;
      }
    }

    if (e.checked == false) {
      for (let i = 0; i < this.allPages.length; i++) {
        this.allPages[i].PSelect = false;
        this.allPages[i].PView = false;
        this.allPages[i].PCreate = false;
        this.allPages[i].PUpdate = false;
        this.allPages[i].PDelete = false;
        this.tabenable = false;
      }
    }
  }

  onViewChange(e: any): void {
    if (e.target.checked == true) {
      this.permission.push(e.target.value);
      for (let i = 0; i < this.allPages.length; i++) {
        if (e.target.value == this.allPages[i].PageName) {
          this.allPages[i].PView = true;
          if (this.allPages[i].PView == true && this.allPages[i].PCreate == true &&
            this.allPages[i].PUpdate == true && this.allPages[i].PDelete == true) {
            this.allPages[i].PSelect = true;
          }
        }

        if (e.target.value == "Stock") {
          this.stocktabenable = true;
        }
        if (e.target.value == "Settings") {
          this.tabenable = true;
        }
      }
    }

    if (e.target.checked == false) {
      this.permission.splice(this.permission.indexOf(e.target.value), 1);
      for (let i = 0; i < this.allPages.length; i++) {
        if (e.target.value == this.allPages[i].PageName) {
          this.allPages[i].PView = false;
          this.allPages[i].PCreate = false;
          this.allPages[i].PUpdate = false;
          this.allPages[i].PDelete = false;
          this.allPages[i].PSelect = false;
        }
        if (e.target.value == "Stock") {
          this.stocktabenable = false;
        }
        if (e.target.value == "Settings") {
          this.tabenable = false;
        }
      }
    }
  }

  onCreateChange(e: any): void {
    if (e.target.checked == true) {
      this.permission.push(e.target.value);
      for (let i = 0; i < this.allPages.length; i++) {
        if (e.target.value == this.allPages[i].PageName) {
          this.allPages[i].PCreate = true;
          if (this.allPages[i].PSelect == false && this.allPages[i].PView == true &&
            this.allPages[i].PCreate == true && this.allPages[i].PUpdate == true &&
            this.allPages[i].PDelete == true) {
            this.allPages[i].PSelect = true;
          }
        }
      }
    }

    if (e.target.checked == false) {
      this.permission.splice(this.permission.indexOf(e.target.value), 1);
      for (let i = 0; i < this.allPages.length; i++) {
        if (e.target.value == this.allPages[i].PageName) {
          this.allPages[i].PCreate = false;
          if (this.allPages[i].PSelect == true && this.allPages[i].PCreate == false &&
            this.allPages[i].PView == true && this.allPages[i].PUpdate == true &&
            this.allPages[i].PDelete == true) {
            this.allPages[i].PSelect = false;
          }
        }
      }
    }
  }

  onUpdateChange(e: any): void {
    if (e.target.checked == true) {
      this.permission.push(e.target.value);
      for (let i = 0; i < this.allPages.length; i++) {
        if (e.target.value == this.allPages[i].PageName) {
          this.allPages[i].PUpdate = true;

          if (this.allPages[i].PSelect == false && this.allPages[i].PView == true &&
            this.allPages[i].PCreate == true && this.allPages[i].PUpdate == true &&
            this.allPages[i].PDelete == true) {
            this.allPages[i].PSelect = true;
          }
        }
      }
    }

    if (e.target.checked == false) {
      this.permission.splice(this.permission.indexOf(e.target.value), 1);
      for (let i = 0; i < this.allPages.length; i++) {
        if (e.target.value == this.allPages[i].PageName) {
          this.allPages[i].PUpdate = false;

          if (this.allPages[i].PSelect == true && this.allPages[i].PCreate == true &&
            this.allPages[i].PView == true && this.allPages[i].PUpdate == false &&
            this.allPages[i].PDelete == true) {
            this.allPages[i].PSelect = false;
          }
        }
      }
    }
  }

  onDeleteChange(e: any): void {
    if (e.target.checked == true) {
      this.permission.push(e.target.value);
      for (let i = 0; i < this.allPages.length; i++) {
        if (e.target.value == this.allPages[i].PageName) {
          this.allPages[i].PDelete = true;

          if (this.allPages[i].PSelect == false && this.allPages[i].PView == true &&
            this.allPages[i].PCreate == true && this.allPages[i].PUpdate == true &&
            this.allPages[i].PDelete == true) {
            this.allPages[i].PSelect = true;
          }
        }
      }
    }

    if (e.target.checked == false) {
      this.permission.splice(this.permission.indexOf(e.target.value), 1);
      for (let i = 0; i < this.allPages.length; i++) {
        if (e.target.value == this.allPages[i].PageName) {
          this.allPages[i].PDelete = false;
          if (this.allPages[i].PSelect == true && this.allPages[i].PCreate == true &&
            this.allPages[i].PView == true && this.allPages[i].PUpdate == true &&
            this.allPages[i].PDelete == false) {
            this.allPages[i].PSelect = false;
          }
        }
      }
    }
  }

  onCheckboxViewChange(e: any): void {
    if (e.target.checked == true) {
      this.permission.push(e.target.value);
      for (let i = 0; i < this.allPages.length; i++) {
        if (e.target.value == this.allPages[i].PageName) {
          this.allPages[i].PView = true;
          if (this.allPages[i].PView == true && this.allPages[i].PCreate == true &&
            this.allPages[i].PUpdate == true && this.allPages[i].PDelete == true) {
            this.allPages[i].PSelect = true;
          }
        }
      }
    }

    if (e.target.checked == false) {
      this.permission.splice(this.permission.indexOf(e.target.value), 1);
      for (let i = 0; i < this.allPages.length; i++) {
        if (e.target.value == this.allPages[i].PageName) {
          this.allPages[i].PView = false;
          this.allPages[i].PCreate = false;
          this.allPages[i].PUpdate = false;
          this.allPages[i].PDelete = false;
          this.allPages[i].PSelect = false;
        }
      }
    }
  }

  onCheckboxCreateChange(e: any): void {
    if (e.target.checked == true) {
      this.permission.push(e.target.value);
      for (let i = 0; i < this.allPages.length; i++) {
        if (e.target.value == this.allPages[i].PageName) {
          this.allPages[i].PCreate = true;
          if (this.allPages[i].PSelect == false && this.allPages[i].PView == true &&
            this.allPages[i].PCreate == true && this.allPages[i].PUpdate == true &&
            this.allPages[i].PDelete == true) {
            this.allPages[i].PSelect = true;
          }
        }
      }
    }

    if (e.target.checked == false) {
      this.permission.splice(this.permission.indexOf(e.target.value), 1);
      for (let i = 0; i < this.allPages.length; i++) {
        if (e.target.value == this.allPages[i].PageName) {
          this.allPages[i].PCreate = false;
          if (this.allPages[i].PSelect == true && this.allPages[i].PCreate == false &&
            this.allPages[i].PView == true && this.allPages[i].PUpdate == true &&
            this.allPages[i].PDelete == true) {
            this.allPages[i].PSelect = false;
          }
        }
      }
    }
  }

  onCheckboxUpdateChange(e: any): void {
    if (e.target.checked == true) {
      this.permission.push(e.target.value);
      for (let i = 0; i < this.allPages.length; i++) {
        if (e.target.value == this.allPages[i].PageName) {
          this.allPages[i].PUpdate = true;
          if (this.allPages[i].PSelect == false && this.allPages[i].PView == true &&
            this.allPages[i].PCreate == true && this.allPages[i].PUpdate == true &&
            this.allPages[i].PDelete == true) {
            this.allPages[i].PSelect = true;
          }
        }
      }
    }

    if (e.target.checked == false) {
      this.permission.splice(this.permission.indexOf(e.target.value), 1);
      for (let i = 0; i < this.allPages.length; i++) {
        if (e.target.value == this.allPages[i].PageName) {
          this.allPages[i].PUpdate = false;

          if (this.allPages[i].PSelect == true && this.allPages[i].PCreate == true &&
            this.allPages[i].PView == true && this.allPages[i].PUpdate == false &&
            this.allPages[i].PDelete == true) {
            this.allPages[i].PSelect = false;
          }
        }
      }
    }
  }

  onCheckboxDeleteChange(e: any): void {
    if (e.target.checked == true) {
      this.permission.push(e.target.value);
      for (let i = 0; i < this.allPages.length; i++) {
        if (e.target.value == this.allPages[i].PageName) {
          this.allPages[i].PDelete = true;
          if (this.allPages[i].PSelect == false && this.allPages[i].PView == true &&
            this.allPages[i].PCreate == true && this.allPages[i].PUpdate == true &&
            this.allPages[i].PDelete == true) {
            this.allPages[i].PSelect = true;
          }
        }
      }
    }

    if (e.target.checked == false) {
      this.permission.splice(this.permission.indexOf(e.target.value), 1);
      for (let i = 0; i < this.allPages.length; i++) {
        if (e.target.value == this.allPages[i].PageName) {
          this.allPages[i].PDelete = false;
          if (this.allPages[i].PSelect == true && this.allPages[i].PCreate == true &&
            this.allPages[i].PView == true && this.allPages[i].PUpdate == true &&
            this.allPages[i].PDelete == false) {
            this.allPages[i].PSelect = false;
          }
        }
      }
    }
  }
}